

import React, { useContext, useEffect, useState } from 'react'

import Paginator from '../../components/ui/Paginator';

import 'bootstrap-daterangepicker/daterangepicker.css';

import { Combo } from '../../models/interfaces';
import { CombosContext } from '../../context/combo/ComboContext';
import { useLocation, useNavigate } from 'react-router-dom';


 

export const CombosPage = () => {
    const [buscar, setBuscar] = useState('');
    const [pageActual, setPageActual] = useState<number>(1);
    const { combos, totalPage, loadCombos, deleteCombo } = useContext(CombosContext);
    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;

    var product ;

    if(state){
        product = state.product;
    }
    
    useEffect(() => {
        loadCombos(product.id);
    }, [pageActual])
   
   
    const filteredData = combos.filter((combo) =>
        combo.stock.name.toString().toLowerCase().includes(buscar.toLowerCase())
    );

    const handleNew = ()=>{
        navigate("/add-product-stock", { state: { product } });
    }   

    const handleEdit = (combo:Combo)=>{
        navigate("/add-product-stock", { state: { product, combo } });
    }

    const handleDelete = async (stockId) => {
        
        const resp = await deleteCombo(product.id, stockId);
        if(resp !== "success"){
            alert(resp);
        }
    }


    return (
        
        <div className='mt-5 container' style={ styles.container }>
             <div>
                <b className='me-1'>Menu:</b>
                <span>{product.name}</span>
            </div>

            <div className="row justify-content-end mt-5">
                <div className=' col-md-3' style={{position: 'revert'}}>
                    <input className="form-control" id="search" type="text" placeholder="Buscar" value={buscar}  onChange={(e) => setBuscar(e.target.value)}/> 
                    
                </div>
                <div className=' col-md-1' style={{position: 'revert'}}>
                    <button type="button" className="btn btn-success" onClick={handleNew}>Nuevo</button>
                </div>
            </div>
           
            <br></br>
            <table id='comboTable' className="table table-hover table-striped">
                <thead className="thead-dark">
                    <tr>
                        <th>Nombre</th>
                        <th>Cantidad</th>
                        <th>Unidad</th>
                        <th  style={{textAlign: 'center'}}>Acciones</th>
                        
                    </tr>
                </thead>
                <tbody >
                {
                    filteredData.length > 0 
                    ?
                    filteredData.map(combo => (
                        <tr key={combo.productId-combo.stockId}>
                            <td>{combo.stock.name}</td>
                            <td>{combo.quantity}</td>
                            <td>{combo.stock.unit}</td>
                          
                            <td style={{textAlign: 'center', width: '170px'}}>
                                <button type="button" className="btn btn-primary" onClick={()=>handleEdit(combo)}> <i className="bi bi-pencil"></i></button>

                                <button type="button" className="btn btn-danger" style={{marginLeft: '10px'}} onClick={()=>handleDelete(combo.stockId)}><i className="bi bi-trash"></i></button>
                            </td>
                        </tr>
                      ))
                    :
                    <tr> <td colSpan={4} className='text-center'>No hay productos del inventario configurados.</td></tr>
                }
                
                
                </tbody>
            </table>    
            
            {
                totalPage > 1 ?  <Paginator totalPage={totalPage} pageActual={pageActual} onChange={(actual)=> setPageActual(actual)} />   : <div />
            }
             <div className='container d-flex align-items-center justify-content-center mt-5'>
                    <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-secondary">Atrás</button>

             </div>
        </div>
        
    )
}


const styles = {
    container: {
        flex:1,
        marginTop: 10,
        marginHorizontal: 20
    }
};
